import { useCallback } from 'react';

import { RAG_TOOL_REQUIREMENTS } from '@frontend/constants/ragToolConfig';
import { Tool } from '@frontend/types';

import { useOperations } from './useOperations';

export function useRAGToolAvailability() {
  const { canInstance } = useOperations();

  const getRAGBlockReason = useCallback(
    (tool: Tool): string | null => {
      const requirements = RAG_TOOL_REQUIREMENTS[tool.name];
      if (!requirements) return null;

      if (requirements.instanceCapabilities) {
        const hasAll = requirements.instanceCapabilities.every(cap => canInstance([cap], false));
        if (!hasAll) return requirements.disabledMessage;
      }

      return null;
    },
    [canInstance]
  );

  return { getRAGBlockReason };
}
